import { Box } from '@factorialco/deprecated-design-system'
import { StatusTag, StatusVariant } from '@factorialco/factorial-one-react/dist/experimental'
import { ProjectManagementProjectStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface StatusTagProps {
  projectStatus: ProjectManagementProjectStatusEnum
}

export const getStatusLabel = (projectStatus: ProjectManagementProjectStatusEnum): string => {
  switch (projectStatus) {
    case 'active':
      return i18n.t('project_management.projects.status.active')
    case 'closed':
      return i18n.t('project_management.projects.status.closed')
    case 'draft':
      return i18n.t('project_management.projects.status.draft')
    case 'processing':
      return i18n.t('project_management.projects.status.processing')
  }
}

export const getStatusColor = (
  projectStatus: ProjectManagementProjectStatusEnum
): StatusVariant => {
  switch (projectStatus) {
    case 'active':
      return 'positive'
    case 'closed':
      return 'neutral'
    case 'processing':
      return 'info'
    case 'draft':
      return 'warning'
  }
}

const ProjectStatusTag = ({ projectStatus }: StatusTagProps) => {
  return (
    <Box width="fit-content">
      <StatusTag variant={getStatusColor(projectStatus)} text={getStatusLabel(projectStatus)} />
    </Box>
  )
}

export default ProjectStatusTag
